import { compose } from 'ramda';
import { connect } from 'react-redux';
import { defaultProps } from 'recompose';

import CommonTable from '@/components/CommonTable';
import {
  updateLimit,
  updatePage,
  updateSort,
} from '@/features/campaignsStatisticsPage/actions';
import {
  getCampaignType,
  getLimit,
  getPage,
  getSort,
} from '@/features/campaignsStatisticsPage/selectors';

import ErrorMessage from '../ErrorMessage';
import FiltersRow from '../Filters';
import HeadRow from '../HeadRow';
import Row from '../Row';
import TotalRow from '../TotalRow';

const mapStateToProps = state => ({
  limit: getLimit(state),
  page: getPage(state),
  sort: getSort(state),
  campaignType: getCampaignType(state),
});

const mapDispatchToProps = { updateLimit, updatePage, updateSort };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  defaultProps({ ErrorMessage, TotalRow, TopRow: FiltersRow, HeadRow, Row }),
)(CommonTable);
